// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sputnik__ConnectedBankAccount-icon__qPjSU{height:32px}`, "",{"version":3,"sources":["webpack://./src/pages/CreditApplicationPages/ConnectBankAccountForm/ConnectedBankAccounts/ConnectedBankAccount/styles.module.scss"],"names":[],"mappings":"AACE,2CACE,WAAA","sourcesContent":[".ConnectedBankAccount {\n  &-icon {\n    height: 32px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ConnectedBankAccount-icon": `sputnik__ConnectedBankAccount-icon__qPjSU`
};
export default ___CSS_LOADER_EXPORT___;
